import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbProdtableApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbProdtable';
    }

    /**
     * 根据ErmodelId 查询数据
     * @param ermodelId 
     * @returns 
     */
    public async getDbTableListByErModelId(ermodelId: number) {
        return await this.send({ ermodelId }, 'getDbTableListByErModelId', Methods.GET);
    }

    /**
     * 根据灰度 TableId 获取生产TableId
     * @param grayTableId 
     * @returns 
     */
    public async getDbProdTableByGrayTableId(grayTableId: number) {
        return await this.send({ grayTableId }, 'getDbProdTableByGrayTableId', Methods.GET);
    }

}